import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "main-nav relative py-2 z-10 align-middle" }
const _hoisted_2 = { class: "flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-12 md:h-16",
  src: _imports_0,
  alt: "ReGrok"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "flex flex-wrap content-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "Search", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "absolute top-8 -right-20 mt-2 p-4 border-2 border-gray-700 rounded bg-gray-900 opacity-95" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "Notifications", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  class: "toggler btn",
  id: "navUserMenu"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zm-4 7a7 7 0 00-7 7h14a7 7 0 00-7-7z"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "absolute" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "nav gap-2 md:gap-6 relative items-center list-none grid grid-flow-col" }
const _hoisted_21 = { class: "main-footer h-auto fixed bottom-0 w-screen text-sm text-gray-500 z-50" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("FAQs")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Terms")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Privacy")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Cookies")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "© 2022 ReGrok", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search = _resolveComponent("search")!
  const _component_notification_count = _resolveComponent("notification-count")!
  const _component_user_menu = _resolveComponent("user-menu")!
  const _component_base_dropdown = _resolveComponent("base-dropdown")!
  const _component_unauthenticated_nav = _resolveComponent("unauthenticated-nav")!
  const _component_PWAPrompt = _resolveComponent("PWAPrompt")!
  const _component_PWAUpdate = _resolveComponent("PWAUpdate")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_post_form = _resolveComponent("post-form")!
  const _component_base_sidebar = _resolveComponent("base-sidebar")!
  const _component_personal_info = _resolveComponent("personal-info")!
  const _component_users_wrapper = _resolveComponent("users-wrapper")!
  const _component_grok_form = _resolveComponent("grok-form")!
  const _component_support_form = _resolveComponent("support-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("button", {
          class: "logo block relative",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo('activities')))
        }, _hoisted_4),
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _createElementVNode("button", {
                class: "pl-4 inline has-tooltip relative mx-0",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSearchBox && _ctx.toggleSearchBox(...args)))
              }, [
                _hoisted_6,
                (_openBlock(), _createElementBlock("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: _normalizeClass(["h-6 w-6", 'w-6 h-6']),
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "svg-inline": '',
                  role: 'presentation',
                  focusable: 'false',
                  tabindex: '-1'
                }, _hoisted_8))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(`relative ${_ctx.searchKlass}`)
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSearchBox && _ctx.toggleSearchBox(...args))),
                    class: "ml-2 cursor-pointer absolute top-2 right-2"
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: _normalizeClass(["h-6 w-6", 'w-3 h-3 text-blue-50 hover:text-gray-700 transition-colors duration-300']),
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "svg-inline": '',
                      role: 'presentation',
                      focusable: 'false',
                      tabindex: '-1'
                    }, _hoisted_11))
                  ]),
                  _createVNode(_component_search, {
                    search: _ctx.search,
                    onClose: _ctx.toggleSearchBox
                  }, null, 8, ["search", "onClose"])
                ])
              ], 2),
              _createElementVNode("button", {
                class: "pl-4 inline has-tooltip relative mx-0",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateTo('notifications')))
              }, [
                _hoisted_12,
                (_openBlock(), _createElementBlock("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: _normalizeClass(["h-6 w-6", 'w-6 h-6']),
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "svg-inline": '',
                  role: 'presentation',
                  focusable: 'false',
                  tabindex: '-1'
                }, _hoisted_14))
              ]),
              _createVNode(_component_notification_count),
              _createVNode(_component_base_dropdown, {
                class: "inline",
                closeOnSelect: true
              }, {
                toggler: _withCtx(() => [
                  _createElementVNode("button", _hoisted_15, [
                    (_openBlock(), _createElementBlock("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: _normalizeClass(["h-6 w-6", 'user-logo']),
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "svg-inline": '',
                      role: 'presentation',
                      focusable: 'false',
                      tabindex: '-1'
                    }, _hoisted_17))
                  ])
                ]),
                content: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_18, [
                    _createVNode(_component_user_menu, {
                      user: _ctx.user,
                      onOpenPostSidebar: _ctx.openPostSidebar,
                      onOpenProfileSidebar: _ctx.openProfileSidebar,
                      onOpenInvitationsSidebar: _ctx.openInvitationsSidebar,
                      onOpenSupportSidebar: _ctx.openSupportSidebar,
                      onOpenGrokSidebar: _ctx.openGrokSidebar,
                      onClear: _ctx.clearSearch
                    }, null, 8, ["user", "onOpenPostSidebar", "onOpenProfileSidebar", "onOpenInvitationsSidebar", "onOpenSupportSidebar", "onOpenGrokSidebar", "onClear"])
                  ])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_19, [
              _createElementVNode("ul", _hoisted_20, [
                _createVNode(_component_unauthenticated_nav, { onOpenSupportSidebar: _ctx.openSupportSidebar }, null, 8, ["onOpenSupportSidebar"])
              ])
            ]))
      ])
    ]),
    _createVNode(_component_PWAPrompt),
    _createVNode(_component_PWAUpdate),
    _createElementVNode("footer", _hoisted_21, [
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          class: "text-gray-300",
          to: { name: 'about' }
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "text-gray-300",
          to: { name: 'faqs' }
        }, {
          default: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/terms" }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/privacy" }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/cookies" }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        }),
        _hoisted_27
      ])
    ]),
    _createVNode(_component_base_sidebar, {
      open: _ctx.postSidebarOpen,
      onCloseSidebar: _ctx.closeSidebar
    }, {
      default: _withCtx(() => [
        _createVNode(_component_post_form, { onCloseSidebar: _ctx.closeSidebar }, null, 8, ["onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["open", "onCloseSidebar"]),
    _createVNode(_component_base_sidebar, {
      open: _ctx.profileSidebarOpen,
      onCloseSidebar: _ctx.closeSidebar
    }, {
      default: _withCtx(() => [
        _createVNode(_component_personal_info, {
          onCloseSidebar: _ctx.closeSidebar,
          edit: true
        }, null, 8, ["onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["open", "onCloseSidebar"]),
    _createVNode(_component_base_sidebar, {
      open: _ctx.invitationsSidebarOpen,
      onCloseSidebar: _ctx.closeSidebar
    }, {
      default: _withCtx(() => [
        _createVNode(_component_users_wrapper, { onCloseSidebar: _ctx.closeSidebar }, null, 8, ["onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["open", "onCloseSidebar"]),
    _createVNode(_component_base_sidebar, {
      open: _ctx.grokSidebarOpen,
      onCloseSidebar: _ctx.closeSidebar
    }, {
      default: _withCtx(() => [
        _createVNode(_component_grok_form, { onCloseSidebar: _ctx.closeSidebar }, null, 8, ["onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["open", "onCloseSidebar"]),
    _createVNode(_component_base_sidebar, {
      open: _ctx.supportSidebarOpen,
      onCloseSidebar: _ctx.closeSidebar
    }, {
      default: _withCtx(() => [
        _createVNode(_component_support_form)
      ]),
      _: 1
    }, 8, ["open", "onCloseSidebar"])
  ], 64))
}